import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { finalize, takeWhile } from 'rxjs/operators';
import { TicketCreate } from '@shared/models/ticket-create';
import { Product } from '@shared/models/product';
import Utils from '@shared/utils/utils';
import { FormGroup } from '@angular/forms';
import Configs from '@shared/constants/configs';
import { Customer } from '@shared/models/customer';
import { ContentsBase } from '@routes/tickets/ticket-edit/contents/contents-base';
import { Basic } from '@shared/models/basic';
import DateUtils from '@shared/utils/date-utils';
import { AttachmentViewComponent } from '@routes/dialogs/attachment-view/attachment-view.component';
import { Attachment } from '@shared/models/ticket-info';
import * as moment from 'moment-timezone';
import { Sc4uInfo } from '@shared/models/sc4u-info';
import { Constants } from '@shared/constants/constants';
import { Company } from '@shared/enums/company';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent extends ContentsBase implements OnInit, OnDestroy {

  IMEI_DIGITS = 15;
  basic: Basic = {};
  customer: Customer = {};
  product: Product = {};
  sc4uInfo: Sc4uInfo = {};
  serverFile: any = {};
  attachment = null;

  isSerialCheck = true;
  isModelCheck = false;
  isDacorModel = false;
  isResetProduct = false;

  productForm: FormGroup;

  isFmrOpen = false;
  fmrIdSearchList = [];

  files: any[] = [];
  key: any;
  filename: string = '';
  bsConfig = {
    containerClass: 'theme-dk',
    showWeekNumbers: false,
    customTodayClass: 'custom-today-class',
    dateInputFormat: Configs.format.date,
  };
  maxDate = new Date();

  customerType = this.constants.customerType;

  isUpdateBos = false;

  @ViewChild('imgFileInput') imgFileInput: ElementRef;
  @ViewChild('bosUpDateFileInput') bosUpDateFileInput: ElementRef;
  readonly Constants = Constants;

  companies = Company;

  get form(): any {
    return this.productForm?.controls;
  }

  ngOnInit(): void {

    this.init('product');
    this.productForm = this.setFormControls('productForm');
    this.ticket.ticketChanged$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticketInfo => {
        if (!ticketInfo) {
          return;
        }
        this.ticket.ticketInfo = ticketInfo;
        const [bosAttachment] = this.ticket.ticketInfo.attachments.filter(f => f.bos) || [];
        this.attachment = bosAttachment;
      });

    if (this.ticketService) {
      this.ticketService.data$
        .pipe(takeWhile(() => this.alive))
        .subscribe((ticket: TicketCreate) => {
          if (Utils.isEmpty(ticket)) {
            return;
          }

          ['basic', 'customer', 'product', 'serverFile', 'sc4uInfo'].forEach(x => {
            this[x] = ticket[x];
          });

          // console.log(`this[serverFile] = ${ this.serverFile }`);

          if (this.basic?.customerType === this.constants.customerType.CUSTOMER) {
            // this.form.demoUnit.setValue(null);
            this.form.fmr.setValue(null);
            this.form.fmrName.setValue(null);
            // this.form.demoUnit.disable();
            this.form.fmrName.disable();
          }

          if (this.basic?.customerType === this.constants.customerType.STORE && this.basic?.displayUnit) {
            // this.form.demoUnit.setValue(true);
            // this.form.demoUnit.checked = true;
            // this.form.demoUnit.disable();
            this.form.fmr.setValue('DLRPRTL01');
            this.form.fmrName.setValue('DLRPRTL01');
            this.selectFmrId({
              code: 'DLRPRTL01',
              name: 'DLRPRTL01'
            });
            // this.form.fmrName.enable();
          }

          let tempProduct = this.ticket.ticketInfo.tempProduct;
          if (tempProduct && this.customer) {
            // console.log('tempProduct && this.customer');
            const { serialNo, modelCode } = tempProduct;
            this.form.serialNo.setValue(serialNo);
            this.form.modelCode.setValue(modelCode);
            this.serialCheck();
            // tempProduct = null;
          }

          if (this.product) {
            this.setFormData(this.product);
          } else {
            this.productForm.reset();
          }

          if (this.isDetail) {
            this.setFormControlDisable(this.form, ['serialNo', 'modelCode', 'imei', 'demoUnit', 'fmrName']);

            const [bosAttachment] = this.ticket.ticketInfo.attachments.filter(f => f.bos) || [];
            this.attachment = bosAttachment;
          }
        });
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  setFormData(data) {
    // console.log('----------------- setFormData ------------');
    const productInfo = data;
    const { serialNo, modelCode, categoryIdNum } = data;

    if (!serialNo && !modelCode) {
      return;
    }
    Object.keys(this.form).forEach(form => {
      // console.log('>>>> this.form.key =', form);
      Object.keys(productInfo).forEach(key => {
        // console.log('>>>>>>>> productInfo =', key);
        if (form === key) {
          if (key === 'purchaseDate') {
            this.form[key].setValue(DateUtils.localDate(productInfo[key]));
          } else {
            this.form[key].setValue(productInfo[key]);
          }

          if (key === 'modelCode') {
            if (!productInfo[key]) {
              this.form[key].enable();
            } else {
              this.form[key].disable();
            }
          }
        }
      });
    });

    this.isSerialCheck = !!modelCode;
    this.isModelCheck = !modelCode;
    this.isDacorModel = ['D3', 'D4', 'D5', 'D7', 'D8', 'DA', 'DB', 'DC', 'DD', 'DE', 'DF', 'DG', 'DH', 'DJ', 'DL', 'DM' ].includes(categoryIdNum);
    if (this.isDacorModel) {
      Swal.fire({
        title: 'Dacor Model',
        html: `<p>Repair requests for this product can be<br> processed at the following site:<br></p><a href="https://dacor.dexwell.com/public-homepage" target="_blank" rel="noopener noreferrer">https://dacor.dexwell.com/public-homepage</a>`,
        confirmButtonText: 'Ok',
        icon: 'warning',
        allowOutsideClick: false,
      }).then(res => {
        this.isDacorModel = !this.isDacorModel;
        this.resetProductInfo();
      })
    }
    if (!modelCode) {
      this.form.modelCode.setErrors({ incorrect: true });
      this.productForm.markAllAsTouched();
      return;
    }
  }

  serialCheck(type?) {

    let { serialNo, modelCode, imei } = this.productForm.getRawValue();

    if (serialNo) {
      this.form.serialNo.setValue(serialNo.toUpperCase());
    }
    if (modelCode) {
      this.form.modelCode.setValue(modelCode?.toUpperCase());
    }
    if (imei) {
      this.form.imei.setValue(imei?.toUpperCase());
      if (imei.length === this.IMEI_DIGITS) {
        imei = imei.toUpperCase();
        serialNo = undefined;
      } else {
        serialNo = imei.toUpperCase();
        imei = undefined;
      }
    }

    const { zipcode } = this.customer?.address;
    const { serviceType } = this.basic;
    const data: any = {
      serialNo: serialNo ? serialNo.toUpperCase() : undefined,
      imei: imei ? imei.toUpperCase() : undefined,
      zipcode,
      serviceType,
      verificationType: type,
    };

    if (type === 'serial' && serialNo && serialNo.toUpperCase() === this.product?.serialNo?.toUpperCase()) {
      return;
    }

    if (type === 'imei' && imei && imei.toUpperCase() === this.product?.imei?.toUpperCase()) {
      return;
    }

    if (type === 'model') {
      data.modelCode = modelCode.toUpperCase();
    }

    this.ticketService.serialInfo(data);
  }

  resetProduct() {
    Swal.fire({
      title: 'Product data including Warranty, Symptom, and Schedule will be deleted, and it cannot be revert.\nDo you want to continue?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        this.resetProductInfo();
      } else if (result.isDenied) {
        Swal.fire('Canceled!', '', 'info');
      }
    });
  }

  resetProductInfo() {
    this.productForm.reset();
    this.ticketService.resetSerial = true;
    this.product = null;
    this.sc4uInfo = null;
    this.isSerialCheck = true;
    this.attachment = undefined;
    this.serverFile = undefined;
    this.form.serialNo.enable();
    this.form.serialNo.setValue(null);
    const data = {
      product: null,
      sc4uInfo: null,
      scheduleDate: null,
      serviceCenter: null,
      symptoms: null,
      pricing: null,
    }

    console.log('isDetail =', this.isDetail, ', attachment =', this.attachment);

    if (this.attachment) {
      // this.fileDelete();
    }
    this.ticketService.patch(data, 'ProductComponent :: resetProduct');
    console.log('isDetail =', this.isDetail, ', attachment =', this.attachment);
    this.form.serialNo.enable();
    // this.isTicketEditable = true;
    this.isResetProduct = true;
  }

  fileSelected(event): any {
    this.attachment = undefined;
    const files = event.target.files;

    console.log('event =', event);
    this.files = files;
    console.log('this.files =', this.files);
    if (this.files.length > 0) {
      const overLimit = Array.from(this.files).some((f: any) => {
        return (f.size > this.configs.fileLimit.limit);
      });

      if (overLimit) {
        this.imgFileInput.nativeElement.value = '';
        const size = (this.configs.fileLimit.limit / (1024 * 1024)).toFixed(0);
        Utils.showError({ message: `The file is too large.  Please select size ${ size }MB or less.` });
        return false;
      }
    }

    const file = files[0];
    this.product.receipt = file.name;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('fileType', 'bos');

    this.apiService.master.serverFileUpload(formData)
      .subscribe(event => {
        if (event.body) {
          const file = {
            _id: event.body._id,
            filename: event.body.filename,
            key: event.body.key,
            secret: event.body.secret,
            bos: event.body.bos,
            tempFile: true,
          };
          this.ticketService.patch({ serverFile: file }, 'product :: file');
          this.attachment = file;
        }
      }, err => {
        Utils.showError(err);
      });
  }

  demoUnitChange() {
    if (this.form.demoUnit.value) {
      this.form.fmrName.enable();
    } else {
      this.form.fmrName.setValue(null);
      this.form.fmr.setValue(null);
      this.form.fmrName.disable();
    }

    this.productForm.markAllAsTouched();

    const product: any = {
      ...this.product,
      demoUnit: this.form.demoUnit.value
    };

    if (!this.form.demoUnit.value && product.fmr) {
      delete product.fmr;
    }

    // this.ticketService.update({ product }, 'demoUnitChange');
    this.ticketService.update({ product }, 'demoUnitChange');
  }

  getFmrIdSearch() {
    this.form.fmr.setValue(null);
    if (!this.form.fmrName.value) {
      return;
    }
    const params = {
      q: this.form.fmrName.value
    };
    this.apiService.product.getFmrIdSearch(params)
      .subscribe(res => {
        this.isFmrOpen = true;
        if (res.length) {
          this.fmrIdSearchList = res;
        } else {
          this.fmrIdSearchList = [];
        }
      }, err => Utils.showError(err));
  }

  selectFmrId(fmrInfo: any) {
    this.isFmrOpen = false;
    this.form.fmr.setValue(fmrInfo.code);
    this.form.fmrName.setValue(fmrInfo.name);

    const product: any = {
      ...this.product,
      fmr: fmrInfo.code,
    };
    this.ticketService.update({ product }, 'selectFmrId');
  }

  outSideClick() {
    if (!this.isFmrOpen) {
      return;
    }
    if (!this.form.fmr.value) {
      this.form.fmrName.setValue(null);
    }
    this.isFmrOpen = false;
  }

  fileDelete() {
    if (!this.basic.ticketNo || this.ticketService.resetSerial) {
      this.product.receipt = null;
      this.ticketService.patch({ serverFile: null }, 'product :: file null');
    } else {
      const params = {
        ticketNo: this.basic.ticketNo,
        attachmentId: this.serverFile._id,
        secret: this.serverFile.secret
      }
      this.spinnerService.start();
      this.apiService.ticket.deleteAttachment(params)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(event => {
          console.log(event);
          this.product.receipt = null;
          this.ticketService.patch({ serverFile: null }, 'product :: file null');
        }, err => {
          Utils.showError(err);
        });
    }
  }


  fileUpdate() {
    if (this.ticketService.resetSerial) {
      this.ticketService.patch({ serverFile: null }, 'product :: file null');
      this.attachment = undefined;
      this.product.receipt = null;
    } else {
      Swal.fire({
        title: 'BOS Update',
        text: 'It deletes the original BOS. Are you sure?',
        icon: 'warning',
        showConfirmButton: true,
        allowOutsideClick: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.attachment = null;
          this.isUpdateBos = !this.isUpdateBos;
          setTimeout(() => {
            this.bosUpDateFileInput.nativeElement.click();
          });
        }
      });
    }
  }

  updateFileSelected(event): any {

    this.isUpdateBos = !this.isUpdateBos;
    const files = event.target.files;

    this.files = files;

    if (this.files.length > 0) {
      const overLimit = Array.from(this.files).some((f: any) => {
        return (f.size > this.configs.fileLimit.limit);
      });

      if (overLimit) {
        this.imgFileInput.nativeElement.value = '';
        const size = (this.configs.fileLimit.limit / (1024 * 1024)).toFixed(0);
        Utils.showError({ message: `The file is too large.  Please select size ${ size }MB or less.` });
        return false;
      }
    }

    const file = files[0];
    file.bos = true;
    this.product.receipt = file.name;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('fileType', 'bos');

    this.spinnerService.start();
    this.apiService.ticket.updateBos(formData, this.basic.ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(event => {
        console.log(event);
        if (event.body) {
          this.setUpdateTicketData(event.body);
          const [firstAttachment] = event.body.attachments;
          this.attachment = firstAttachment;
        }
      }, err => {
        Utils.showError(err);
      });
  }

  async selectFile(isTempFile = false) {
    if (isTempFile) {
      const { _id, secret, filename } = this.attachment?.tempServerFile;
      const url = this.apiService.master.imageUrl(_id, this.basic.ticketNo, secret);
      this.fileService.downloadFile(url, filename);
      return;
    }

    if (this.isImageFile(this.attachment)) {
      await this.showAttachmentViewer(this.ticket.ticketInfo, this.attachment);
    } else {
      const { filename } = this.attachment;
      const url = this.apiService.ticket.attachmentUrl(this.ticket.ticketInfo, this.attachment, 'attachment');
      this.fileService.downloadFile(url, filename);
    }
  }

  isImageFile(file): boolean {
    const name: string = file.filename;
    if (!name) {
      return false;
    }
    return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(name.toLowerCase());
  }

  showAttachmentViewer(ticketInfo, attachment: Attachment) {
    const src = this.apiService.ticket.attachmentUrl(ticketInfo, attachment, 'inline');

    const initialState = {
      attachmentImage: src,
      params: {
        ticketInfo,
        attachment,
      },
    };

    this.modalService.show(AttachmentViewComponent, {
      initialState,
      class: 'modal-lg',
    });
  }

  openCalendarValueChange(value) {
    if (!this.product) {
      return;
    }
    const { purchaseDate } = this.product;

    let inputDate = moment(value).format(Configs.format.serverLocalDate);
    let preDate = !purchaseDate ? purchaseDate : moment(purchaseDate).format(Configs.format.serverLocalDate);

    if (!value || !moment(inputDate).isValid || inputDate === preDate) {
      return;
    }

    const product: any = {
      ...this.product,
      purchaseDate: inputDate,
    };
    this.ticketService.update({ product }, 'openCalendarValueChange');
  }

  setUpdateTicketData(res) {
    const ticket = this.ticket;
    ticket.isEdit = false;
    ticket.ticketInfo = res;

    this.ticketManager.updateTicket = ticket;
  }


}
